export const services = [
  {
    title: "AI Photo & Video",
    desc: "Foto produk dan video AI untuk affiliate, konten media sosial, katalog, dan promosi brand. Pesan Video Konten Produk, Cinematic TV Ads, atau Photo Studio melalui form Flow."
  },
  {
    title: "Product Designs & UI/UX",
    desc: "Desain produk kami menggabungkan estetika yang modern dan inovatif dengan fungsionalitas yang dirancang secara khusus, didorong oleh visi yang kuat untuk menciptakan pengalaman pengguna yang mulus dan bermakna."
  },
  {
    title: "Website Development",
    desc: "Website dikembangkan dengan pendekatan yang mengutamakan tampilan modern, performa yang stabil, dan pengalaman pengguna yang nyaman. Setiap elemen dirancang secara menyeluruh agar selaras dengan kebutuhan brand, sekaligus mudah diakses, responsif, dan siap berkembang."
  },
  {
    title: "Mobile Applications",
    desc: "Aplikasi mobile dirancang dengan fokus pada kenyamanan pengguna, alur interaksi yang intuitif, serta performa yang andal. Setiap proses pengembangan dilakukan secara menyeluruh agar aplikasi tidak hanya menarik secara visual, tetapi juga stabil, responsif, dan siap digunakan dalam jangka panjang."
  },
  {
    title: "Roblox Game Development",
    desc: "Kami menyediakan jasa pengembangan game Roblox yang menggabungkan kreativitas, mekanik gameplay yang solid, dan sistem yang teroptimasi. Setiap game dirancang secara custom untuk menghadirkan pengalaman bermain yang seru, stabil, dan berkesan bagi pemain."
  },
  {
    title: "Augmented Reality (AR)",
    desc: "Pengalaman augmented reality dirancang untuk menyatukan dunia digital dan nyata secara natural. Setiap interaksi dibangun dengan perhatian pada detail visual, performa yang stabil, dan alur penggunaan yang intuitif, sehingga teknologi dapat terasa imersif, relevan, dan mudah digunakan."
  },
];
